// ---------------------------------------------------------------------------
// Seed data — contoh data untuk fitur "Buatkan Contoh" di halaman admin
// ---------------------------------------------------------------------------

export const SEED_PORTFOLIO = [
  {
    title: "Makeup Pengantin Adat Solo",
    category: "Pengantin",
    imageRef: null,
  },
  {
    title: "Makeup Wisuda Modern",
    category: "Wisuda",
    imageRef: null,
  },
  {
    title: "Makeup Pesta Elegan",
    category: "Pesta",
    imageRef: null,
  },
  {
    title: "Makeup Foto Prewedding",
    category: "Prewedding",
    imageRef: null,
  },
];

export const SEED_CERTIFICATES = [
  {
    title: "Sertifikat Makeup Artist Profesional",
    issuer: "Lembaga Kecantikan Indonesia",
    date: "2024-01-15",
    imageRef: null,
  },
  {
    title: "Sertifikat Bridal Makeup Specialist",
    issuer: "International Beauty Academy",
    date: "2024-06-20",
    imageRef: null,
  },
  {
    title: "Sertifikat Airbrush Makeup",
    issuer: "Kursus Tata Rias Modern",
    date: "2023-11-10",
    imageRef: null,
  },
];

export const SEED_PRICELIST = {
  reguler: {
    name: "Reguler",
    price: "500.000",
    desc: "Paket makeup reguler untuk acara formal",
    items: [
      { name: "Makeup Wisuda", price: "350.000", desc: "Makeup natural untuk wisuda" },
      { name: "Makeup Pesta", price: "500.000", desc: "Makeup glowing untuk pesta" },
      { name: "Makeup Lamaran", price: "750.000", desc: "Makeup tahan lama untuk lamaran" },
    ],
  },
  premium: {
    name: "Premium",
    price: "1.500.000",
    desc: "Paket makeup premium dengan prioritas",
    items: [
      { name: "Makeup Pengantin", price: "3.000.000", desc: "Makeup pengantin lengkap dengan sungging" },
      { name: "Makeup Ibu & Putri", price: "4.500.000", desc: "Makeup untuk ibu dan putri" },
      { name: "Makeup Bridesmaid", price: "1.500.000", desc: "Makeup untuk pendamping pengantin" },
    ],
  },
};

export const SEED_FAQS = [
  {
    question: "Berapa lama proses makeup pengantin?",
    answer: "Proses makeup pengantin biasanya memakan waktu 2–3 jam tergantung kompleksitas riasan dan jumlah orang yang akan dirias.",
  },
  {
    question: "Apakah menyediakan trial makeup?",
    answer: "Ya, kami menyediakan sesi trial makeup sebelum hari H agar hasil makeup sesuai dengan keinginan Anda.",
  },
  {
    question: "Apakah MUA datang ke lokasi?",
    answer: "Tentu, kami melayani makeup on-location di seluruh area Solo Raya dan sekitarnya dengan biaya transportasi tambahan.",
  },
  {
    question: "Produk makeup apa yang digunakan?",
    answer: "Kami menggunakan produk makeup branded dan berkualitas tinggi yang aman untuk semua jenis kulit, termasuk kulit sensitif.",
  },
];

export const SEED_PACKAGES = [
  {
    name: "Basic",
    tier: "Wedding Package",
    price: "5",
    unit: "Juta",
    currency: "IDR",
    tagline: "Cocok untuk akad sederhana",
    features: ["Makeup pengantin", "Sungging", "1x trial", "Konsultasi"],
    highlight: false,
  },
  {
    name: "Premium",
    tier: "Wedding Package",
    price: "10",
    unit: "Juta",
    currency: "IDR",
    tagline: "Makeup lengkap untuk hari spesial",
    features: [
      "Makeup pengantin + ibu",
      "Sungging",
      "2x trial",
      "Konsultasi",
      "Aksesoris tambahan",
    ],
    highlight: true,
  },
  {
    name: "Exclusive",
    tier: "Wedding Package",
    price: "15",
    unit: "Juta",
    currency: "IDR",
    tagline: "Full tim untuk pengalaman terbaik",
    features: [
      "Makeup pengantin + ibu + bridesmaid",
      "Sungging",
      "Unlimited trial",
      "Konsultasi",
      "Aksesoris lengkap",
      "Hairdo",
    ],
    highlight: false,
  },
];

export const SEED_TESTIMONIALS = [
  {
    name: "Sari Dewi",
    role: "Pengantin",
    quote: "Makeupnya cantik banget dan tahan seharian! Makasih Mbak sudah membuat hari spesialku semakin sempurna.",
    avatarRef: null,
  },
  {
    name: "Ayu Lestari",
    role: "Wisudawan",
    quote: "Pertama kali makeup profesional, hasilnya natural dan glowing. Recommended banget!",
    avatarRef: null,
  },
  {
    name: "Dian Permata",
    role: "Ibu Pengantin",
    quote: "Profesional dan ramah. Hasil makeupnya elegan, aku dan putriku puas sekali.",
    avatarRef: null,
  },
];

export const SEED_PRESS = [
  "Majalah Femina — Januari 2024",
  "Koran Solo Pos — Maret 2024",
  "Blog WeddingIndo — Juni 2024",
  "Majalah Ayu — September 2024",
];

export const SEED_SERVICES = [
  {
    title: "Makeup Pengantin",
    subtitle: "Bridal Makeup",
    description:
      "Rias pengantin adat maupun modern dengan sungging tradisional. Cocok untuk pernikahan adat Solo, Jogja, dan budaya Jawa lainnya.",
    priceFrom: "3.000.000",
    icon: "Sparkles",
    imageRef: null,
  },
  {
    title: "Makeup Wisuda",
    subtitle: "Graduation Makeup",
    description:
      "Makeup natural dan glowing untuk momen wisuda yang tak terlupakan. Tahan lama dan tetap fresh sepanjang acara.",
    priceFrom: "350.000",
    icon: "GraduationCap",
    imageRef: null,
  },
  {
    title: "Makeup Pesta",
    subtitle: "Party Makeup",
    description:
      "Rias pesta elegant dengan pilihan tema warna yang dapat disesuaikan dengan gaun dan acara Anda.",
    priceFrom: "500.000",
    icon: "Camera",
    imageRef: null,
  },
  {
    title: "Sanggar & Pelatihan",
    subtitle: "Makeup Class",
    description:
      "Kelas makeup untuk pemula hingga mahir. Pelajari teknik rias profesional dengan praktik langsung.",
    priceFrom: "500.000",
    icon: "BookOpen",
    imageRef: null,
  },
];
